import React, {useCallback, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Dropdown, {DropdownTrigger, DropdownContent} from 'react-simple-dropdown';

import {
  Radio,
  Pagination,
  Checkbox,
  ShowItemsSelect,
  Message,
} from '../utilites';
import {userService} from '../../services/user-service';
import Loader from './Loader/Loader';
import {pageOptions} from '../../helpers/data-constants';
import {getUserFromLocalStorage, permissionsAccess} from '../../helpers/common';
import {USER_INFO} from '../../constants/localStorageConstants';

import './users.scss';
import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_dropdown.scss';
import '../../assets/styles/components/_content-tabs.scss';

import AngleDownIcon from '../../assets/icons/angle-down.svg';
import AddClientIcon from '../../assets/icons/add-client.svg';
import {messages} from '../../helpers/messages';
import {useSelector} from "react-redux";

const roleMap = {
  GOODS_SPECIALIST: 'Товаровед',
  ACCOUNTANT: 'Бухгалтер',
  ADMIN: 'Администратор',
  DIRECTOR: 'Директор',
  MARKETER: 'Маркетолог',
  BRANCH_DIRECTOR: 'Директор филиала',
  LOYAL_GOODS_SPECIALIST: 'Лояльный товаровед'
};

const Users = ({setTitlePage}) => {
  const [state, setState] = useState({
    users: [],
    total: 0,
    currentPage: 1,
    loading: false,
    size: pageOptions[0].value,
    filters: {active: true},
    error: '' || null,
  });
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user)
  const buildDataForSearch = useCallback(() => {
    let data = {};
    data.page = state.currentPage;
    data.size = state.size;
    data.filters = state.filters;
    data.sortBy = 'fullName';

    return data;
  }, [state.currentPage, state.filters, state.size]);

  const getUsers = useCallback(
    (userId) => {
      let data = buildDataForSearch();

      setState((prev) => ({
        ...prev,
        loading: true,
      }));
      userService.getUsers(data).then((response) => {
        const activeUser = getUserFromLocalStorage();

        setState((prev) => ({
          ...prev,
          users: response.data.users,
          total: response.data.total,
          loading: false,
        }));

        if (userId && activeUser && activeUser.id === userId) {
          activeUser.roles = response.data.users.find((i) => i.id === activeUser.id).roles;
          localStorage.setItem(USER_INFO, JSON.stringify(activeUser));
        }
      });
    },
    [buildDataForSearch]
  );

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Пользователи');
  }, [isLoadingConfiguration]);

  useEffect(() => {
    permissionsAccess("action.employee.list") && getUsers();
  }, [state.size, state.filters, state.currentPage, getUsers]);

  const handleSearchTypeChange = (event) => {
    let filters = {};
    const target = event?.target;
    const id = target.id;

    switch (id) {
      case 'activeUsers':
        filters.active = true;
        break;
      case 'inactiveUsers':
        filters.active = false;
        break;
      default:
        break;
    }

    setState((prev) => ({
      ...prev,
      filters: filters,
      currentPage: 1,
      error: null,
    }));
  };

  const handleRoleChange = (userId, roles, event) => {
    if (!permissionsAccess("action.employee.update.roles")) {
      return false
    }
    const name = event?.target?.name;
    if (roles.includes(name)) {
      roles.splice(roles.indexOf(name), 1);
    } else {
      roles.push(name);
    }

    setState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    userService.editRoles(userId, {roles})
      .then(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
        getUsers(userId);
      })
      .catch((err) => {
        if (err.response) {
          let errorData = err.response.data;
          let commonError = messages["0"];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          setState((prev) => ({
            ...prev,
            loading: false,
            error: commonError,
          }));
        }
      });
  };

  const onPageSizeChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setState((prev) => ({
      ...prev,
      size: parseInt(value),
      currentPage: 1,
      error: null,
    }));
  };

  const handlePageChange = (page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
      error: null,
    }));
  };

  const renderTableData = () => {
    return state.users.map((user) => {
      const {id, fullName, position, roles, department, active} = user;
      return (
        <tr key={id} className={active ? '' : 'disabled'}>
          <th scope="row">
            <span className="caption">Пользователь</span>
            <div className="table-cellcontent">
              {
                permissionsAccess("action.employee.details")
                  ? <p>
                    <Link className="table-link" to={'user/' + id}>
                      <span>{fullName}</span>
                    </Link>
                  </p>
                  : <p>
                    <span>{fullName}</span>
                  </p>
              }
            </div>
          </th>
          <td>
            <span className="caption">Должность</span>
            <div className="table-celltrigger">
              <p>{position}</p>
            </div>
          </td>
          <td>
            <span className="caption">Подразделение</span>
            <p>{department}</p>
          </td>
          <td>
            <span className="caption">Роль</span>
            <div className="d-flex">
              <div className="roles">
                {roles.map((role) => (
                  <p key={role}>{roleMap[role]}</p>
                ))}
              </div>
              <div className="table-celltrigger-actions">
                <Dropdown className="dropdown-right dropdown-caret">
                  <DropdownTrigger className="button-icontrigger small">
                    <span className="icon">
                      <AngleDownIcon/>
                    </span>
                  </DropdownTrigger>
                  <DropdownContent>
                    <div className="dropdown-content caret">
                      <div className="dropdown-content-data">
                        <div className="form-element">
                          <label className="form-element-label" htmlFor="">
                            Роли пользователя
                          </label>
                          <div className="form-element-data">
                            <div className="form-element-data-checkboxes">
                              <Checkbox
                                label="Товаровед"
                                name="GOODS_SPECIALIST"
                                checked={roles.includes('GOODS_SPECIALIST')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />
                              <Checkbox
                                label="Бухгалтер"
                                name="ACCOUNTANT"
                                checked={roles.includes('ACCOUNTANT')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />
                              <Checkbox
                                label="Администратор"
                                name="ADMIN"
                                checked={roles.includes('ADMIN')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />
                              <Checkbox
                                label="Директор"
                                name="DIRECTOR"
                                checked={roles.includes('DIRECTOR')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />
                              <Checkbox
                                label="Маркетолог"
                                name="MARKETER"
                                checked={roles.includes('MARKETER')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />
                              {accessFeatures['branches'] && <Checkbox
                                label="Директор филиала"
                                name="BRANCH_DIRECTOR"
                                checked={roles.includes('BRANCH_DIRECTOR')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />}
                              {accessFeatures['report.remotely_reports'] && <Checkbox
                                label="Лояльный товаровед"
                                name="LOYAL_GOODS_SPECIALIST"
                                checked={roles.includes('LOYAL_GOODS_SPECIALIST')}
                                onChange={(e) => handleRoleChange(id, roles, e)}
                              />}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DropdownContent>
                </Dropdown>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <main className="app-content">
      {isLoadingConfiguration ?
        (<div className="content-inner">
          <Loader pageRange={1}/>
        </div>) :
        (<>
          {!accessFeatures['title.header_section'] &&
            <div className="content-header">
              <h1>Пользователи</h1>
            </div>}

          <div className="content-inner">
            <div className="content-inner-data">
              {state.error && <Message type="error" text={state.error}/>}
              <div className="content-inner-data-container">
                <div className="content-datatable">
                  <div className="content-datatable-header sticky">
                    <div className="content-datatable-header-left">
                      <div className="action-items">
                        <div className="pillbox-radiogroup" onChange={handleSearchTypeChange}>
                          <Radio
                            pillboxStyle={true}
                            label="Все"
                            id="allUsers"
                            name="radioUsersSwitcher"
                          />
                          <Radio
                            pillboxStyle={true}
                            label="Активные"
                            id="activeUsers"
                            name="radioUsersSwitcher"
                            checked={true}
                          />
                          <Radio
                            pillboxStyle={true}
                            label="Неактивные"
                            id="inactiveUsers"
                            name="radioUsersSwitcher"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="content-datatable-header-right">
                      <ShowItemsSelect
                        wrapClass="action-items"
                        options={pageOptions}
                        change={onPageSizeChange}
                      />
                      {
                        permissionsAccess("action.employee.create") &&
                        <div className="action-items">
                          <Link className="button-icontrigger-accent caption hover" to="/user">
                      <span className="icon">
                        <AddClientIcon/>
                      </span>
                            <span>Создать пользователя</span>
                          </Link>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="content-datatable-content">
                    {state.loading ? (
                      <Loader pageRange={state.size}/>
                    ) : (
                      <table className="table hover">
                        <thead>
                        <tr>
                          <th scope="col">Ф.И.О.</th>
                          <th scope="col">Должность</th>
                          <th scope="col">Подразделение</th>
                          <th scope="col">Роль</th>
                        </tr>
                        </thead>
                        <tbody>{renderTableData()}</tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <Pagination
                total={Math.ceil(state.total / state.size)}
                current={state.currentPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </>)
      }
    </main>
  );
};

export default Users;
